import { useLayoutEffect, useRef, useState } from 'react';
import { useLoadStore } from '../../stores/use-load-store';
import gsap from 'gsap';
import './load.scss';

export default function Load({ onLoad }: { onLoad: () => void }) {
  const { progress } = useLoadStore();
  const [animProgress, setAnimProgress] = useState(0);
  const elRef = useRef(null);
  useLayoutEffect(() => {
    let animId = 0;
    const anim = () => {
      setAnimProgress(prevAnimProgress => {
        const newAnimProgress =
          prevAnimProgress + (progress - prevAnimProgress) * 0.1;
        if (newAnimProgress > 0.99) {
          cancelAnimationFrame(animId);
          gsap.to(elRef.current, {
            opacity: 0,
            delay: 1,
            onComplete: onLoad,
          });
          return 1; // 确保动画进度不超过1
        }
        return newAnimProgress;
      });
      animId = requestAnimationFrame(anim);
    };
    animId = requestAnimationFrame(anim);
    return () => {
      cancelAnimationFrame(animId);
    };
  }, [progress, onLoad]);
  return (
    <div className="fit_parent bg-white z-20" ref={elRef}>
      <video
        poster={process.env.PUBLIC_URL + '/images/poster.jpg'}
        className="fit_parent object-cover object-center"
        src={process.env.PUBLIC_URL + '/videos/loading.mp4'}
        autoPlay
        muted
        loop
      ></video>
      <div className="fit_parent justify-center">
        <div className="load_bg absolute top-1/2 left-1/2 text-center w-full mt-[7vh] -translate-x-1/2"></div>
        <p className="progress text-[#689a99] absolute top-1/2 text-center w-full mt-[7vh]">
          {Math.round(animProgress * 100) + '%'}
        </p>
      </div>
    </div>
  );
}
